var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDna(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 73.352 33.287 c -1.16 0 -2.35 -0.064 -3.563 -0.193 c -0.824 -0.088 -1.42 -0.827 -1.332 -1.651 c 0.088 -0.825 0.841 -1.413 1.65 -1.333 c 7.211 0.774 13.366 -0.99 17.333 -4.956 c 0.586 -0.586 1.535 -0.586 2.121 0 s 0.586 1.536 0 2.121 C 85.631 31.205 79.962 33.287 73.352 33.287 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "white",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 26.214 90 c -0.384 0 -0.768 -0.146 -1.061 -0.439 c -0.586 -0.586 -0.586 -1.535 0 -2.121 c 5.682 -5.683 6.724 -15.295 2.858 -26.374 C 24.045 49.694 24.94 39.392 30.467 32.8 c 4.991 -5.954 13.106 -8.365 22.838 -6.79 c 0.818 0.132 1.374 0.903 1.241 1.721 s -0.907 1.366 -1.72 1.241 c -8.652 -1.401 -15.775 0.645 -20.061 5.755 c -4.831 5.762 -5.531 15.001 -1.92 25.35 c 4.259 12.209 2.958 22.955 -3.57 29.483 C 26.982 89.854 26.598 90 26.214 90 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "white",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 42.32 64.459 c -1.732 0 -3.535 -0.144 -5.399 -0.434 c -0.818 -0.128 -1.379 -0.895 -1.251 -1.713 c 0.127 -0.819 0.897 -1.372 1.713 -1.252 c 8.575 1.34 15.636 -0.731 19.881 -5.823 c 4.804 -5.764 5.493 -14.99 1.892 -25.314 c -4.259 -12.21 -2.958 -22.956 3.57 -29.483 c 0.586 -0.586 1.535 -0.586 2.121 0 s 0.586 1.536 0 2.121 c -5.682 5.682 -6.724 15.294 -2.859 26.374 c 3.958 11.344 3.076 21.631 -2.419 28.224 C 55.577 61.946 49.567 64.459 42.32 64.459 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "white",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.5 65.286 c -0.384 0 -0.768 -0.146 -1.061 -0.439 c -0.586 -0.586 -0.586 -1.535 0 -2.121 c 5.047 -5.047 12.812 -7.013 21.865 -5.536 c 0.817 0.134 1.372 0.904 1.239 1.722 c -0.134 0.818 -0.907 1.372 -1.722 1.239 c -8.073 -1.316 -14.914 0.35 -19.26 4.696 C 2.268 65.14 1.884 65.286 1.5 65.286 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "white",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 61.713 51.758 c -0.384 0 -0.768 -0.146 -1.061 -0.439 L 38.685 29.351 c -0.586 -0.585 -0.586 -1.536 0 -2.121 c 0.586 -0.586 1.535 -0.586 2.121 0 l 21.968 21.968 c 0.586 0.586 0.586 1.535 0 2.121 C 62.48 51.611 62.097 51.758 61.713 51.758 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "white",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50.258 63.213 c -0.384 0 -0.768 -0.146 -1.061 -0.439 L 27.229 40.806 c -0.586 -0.585 -0.586 -1.536 0 -2.121 c 0.586 -0.586 1.535 -0.586 2.121 0 l 21.968 21.968 c 0.586 0.586 0.586 1.535 0 2.121 C 51.025 63.066 50.642 63.213 50.258 63.213 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "white",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 82.111 31.79 c -0.384 0 -0.768 -0.146 -1.061 -0.439 L 58.646 8.946 c -0.586 -0.585 -0.586 -1.536 0 -2.121 c 0.586 -0.586 1.535 -0.586 2.121 0 l 22.404 22.405 c 0.586 0.585 0.586 1.536 0 2.121 C 82.879 31.644 82.495 31.79 82.111 31.79 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "white",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 29.133 84.769 c -0.384 0 -0.768 -0.146 -1.061 -0.439 L 5.667 61.925 c -0.586 -0.586 -0.586 -1.535 0 -2.121 s 1.535 -0.586 2.121 0 l 22.405 22.404 c 0.586 0.586 0.586 1.535 0 2.121 C 29.9 84.622 29.517 84.769 29.133 84.769 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "white",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDna);
export default __webpack_public_path__ + "static/media/dna.18dfe71143c10e7845c9d29568291301.svg";
export { ForwardRef as ReactComponent };